import { ChangeEvent, FC, useRef } from 'react'
import { webchatClasses } from '../../../../styles/classes'
import { Plus } from 'lucide-react'

type FileUploaderProps = {
  disabled: boolean
  onFileSelected: (file: File) => void
}

export const FileInputButton: FC<FileUploaderProps> = ({ disabled, onFileSelected }) => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const { uploadButton } = webchatClasses.composer

  const handleUploadFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  const handleFileSelected = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files

    if (files && files.length > 0) {
      Array.from(files).forEach((file) => {
        onFileSelected(file)
      })
    }
  }

  return (
    <>
      <Plus
        {...uploadButton}
        role="button"
        tabIndex={0}
        aria-label="Upload File Button"
        data-disabled={disabled}
        onClick={handleUploadFileClick}
      />
      <input
        value=""
        multiple
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileSelected}
      />
    </>
  )
}
